module.exports = __webpack_public_path__ + "static/img/egg_r_01.870c98a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_01.png
// module id = 7bm3
// module chunks = 1